module.exports = __webpack_public_path__ + "img/hero_landlord_1920.0eea27b8.png";